<template>
  <div class="d-f ai-c p-x-3 p-t-3 translation">
    <div class="icon d-f ai-c jc-c m-r-3 m-b-3 as-fs">
      <i class="icon-text-24" />
    </div>
    <div class="d-f f-g fd-c fd-md-r f-1">
      <div class="f-1">
        <h3>{{ data.string }}</h3>
        <p>{{ data.description }}</p>
      </div>
      <div class="f-1 m-b-md-0">
        <form-input class="thin f-w" :resetable="data.value !== ''" :placeholder="data.placeholder" v-model="data.value" @reset="reset" @input="input" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    data: {
      type: Object,
      required: true,
    },
    id: {
      type: String,
      required: true,
    },
  },
  methods: {
    reset() {
      this.data.value = this.data.origValue;
      this.$emit('change', { key: this.id, value: '' });
    },
    input(value) {
      this.$emit('change', { key: this.id, value });
    },
  },
};
</script>

<style lang="scss" scoped>
.translation {
  &:not(:last-child) {
    border-bottom: 1px solid #eef0f9;
  }
}

h3 {
  font-weight: 600;
  font-size: 16px;
  line-height: 22px;
}

p {
  color: var(--color-cta-darkgray);
  font-size: 13px;
  line-height: 18px;
}

.icon {
  background-color: #f0f2f5;
  border-radius: 3px;
  height: 80px;
  min-height: 80px;
  min-width: 80px;
  width: 80px;

  i {
    color: var(--color-cta-blue);
    font-size: 24px;
  }
}
</style>
